module.exports = __webpack_public_path__ + "static/img/dianxin_active.7235245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newimg/dianxin_active.png
// module id = dpfD
// module chunks = 0